import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid } from '@mui/material';
import { ArrowLeftOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { Input, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useForm } from 'react-hook-form';
import CkeditorField from '../../../../components/inputs/CkeditorField';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BTextField from '../../../../components/inputs/forms/BTextField';
import { setValues, onChangeForBComponents, convertArrayToKeyedObject } from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import BSelectField from '../../../../components/inputs/forms/BSelectField';
import BTextareaField from '../../../../components/inputs/forms/BTextareaField';
import BMultiSelectField from '../../../../components/inputs/forms/BMultiSelectField';
import Table from '../../../../components/tables/Table';
import useTableActions from '../../../../hooks/useTableActions';

const initialItem = {
  name: '',
  description: '',
  display: true,
  service_id: null,
  content: '',
  videos: [],
  price: '',
  off_price: '',
  new: true,
  special: true,
  popular: true,
  image: null,
  banner: null,
};

const cookies = new Cookies();
const url = process.env.REACT_APP_SITE_URL;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

function Quote({ quote, index }) {
  return (
    <Draggable draggableId={quote.id} index={index} key={index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
          {quote.content}
        </div>
      )}
    </Draggable>
  );
}

const QuoteList = React.memo(({ quotes }) =>
  quotes.map((quote, index) => <Quote quote={quote} index={index} key={index} />),
);

const CoursePage = (props) => {
  const navigate = useNavigate();
  const { staticContext, ...rest } = props;
  const { globalState, saveItem, fetchItem } = useContext(DashboardPanelContext);
  const [services, setServices] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [sliderImage, setSliderImage] = useState(null);
  const [courseImage, setCourseImage] = useState(null);
  const { viewReadOnly } = globalState;
  const [courseCustomers, setCourseCustomers] = useState([]);
  const [columns, setColumns] = useState([]);
  const tableRef = useRef(null);
  const [key, setKey] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [totalPageNumber, setTotalPageNumber] = useState(10);
  const [courses, setCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [textEditor, setTextEditor] = useState('');
  const [isLayoutReady, setIsLayoutReady] = useState(false);
  const editorContainerRef = useRef(null);
  const editorToolbarRef = useRef(null);
  const editorRef = useRef(null);

  useEffect(() => {
    setIsLayoutReady(true);

    return () => setIsLayoutReady(false);
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue } = useForm();
  const [state, setState] = useState({ quotes: videos });

  useEffect(() => {
    fetchItem({
      modelName: `/services`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1') {
            res.push(response.data?.data[i]);
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/services?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r.data?.data[n].display === '1') {
                  res.push(r.data?.data[n]);
                }
              }
            });
          }
        }
        setServices(res);
      }
    });
    fetchItem({
      modelName: `/videos`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1') {
            res.push(response.data?.data[i]);
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/videos?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r.data?.data[n].display === '1') {
                  res.push(r.data?.data[n]);
                }
              }
            });
          }
        }
        setAllVideos(res);
        setVideos(res);
      }
    });
    fetchItem({
      modelName: `/customers`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1') {
            const user = response.data?.data[i].user;
            if (user) {
              user.id = response.data?.data[i]?.id;
              res.push(user);
            }
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/customers?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r?.data?.data[n]?.display === '1') {
                  const _user = r.data?.data[n].user;
                  if (_user) {
                    _user.id = r.data?.data[n]?.id;
                    res.push(_user);
                  }
                }
              }
            });
          }
        }
        setCustomers(res);
      }
    });
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder='جستجو'
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size='small'
            style={{
              width: 90,
            }}
          >
            ریست
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            فیلتر
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close();
            }}
          >
            بستن
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) => <div>{text}</div>,
  });

  useEffect(() => {
    setColumns([
      {
        title: 'نام',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
      },
      {
        title: 'ایمیل',
        dataIndex: 'email',
        key: 'email',
        ...getColumnSearchProps('email'),
      },
      {
        title: 'موبایل',
        dataIndex: 'mobile',
        key: 'mobile',
        ...getColumnSearchProps('mobile'),
      },
    ]);
    setKey(key + 1);
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const quotes = reorder(state.quotes, result.source.index, result.destination.index);

    setState({ quotes });
  };

  const {
    id,
    item: currentItem,
    setItem: setCurrentItem,
  } = useBasicInformationMountedEffect({
    match: { params: props.param },
    fetchItemURL: '/courses',
    localStorageKey: 'courses',
    initialItem,
  });

  useEffect(() => {
    fetchItem({
      modelName: `/courses`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1' && Number(response.data?.data[i]?.id) !== Number(id)) {
            res.push(response.data?.data[i]);
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/courses?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r.data?.data[n].display === '1' && Number(r.data?.data[n]?.id) !== Number(id)) {
                  res.push(r.data?.data[n]);
                }
              }
            });
          }
        }
        setCourses(res);
      }
    });
  }, [id]);

  const getCourseCustomerList = useCallback(() => {
    if (id && customers.length > 0) {
      fetchItem({
        modelName: `/courses/${id}/customer-list`,
        showLoader: true,
      }).then((response) => {
        if (response) {
          const res = [];
          const number_of_pages = response.data?.last_page;
          setTotalPageNumber(number_of_pages * 10);
          for (let i = 0; i < response.data?.data?.length; i++) {
            if (response.data?.data[i].display === '1') {
              const user = customers.find((customer) => String(customer.id) === String(response.data?.data[i].id));
              if (user) {
                Object.keys(user).forEach((userKey) => {
                  if (user[userKey] === 'null') {
                    user[userKey] = '';
                  }
                });
                res.push(user);
              }
            }
          }
          setCourseCustomers(res);
        }
      });
    }
  }, [customers, id]);

  useEffect(() => {
    getCourseCustomerList();
  }, [id, customers]);

  const fileSelectedHandlerLoad = async (e) => {
    setSliderImage(null);
    const name = url.concat(e);
    const imgSrc = `${name}?w=164&h=164&fit=crop&auto=format`;
    // eslint-disable-next-line no-shadow
    setSliderImage({ img: imgSrc });
  };

  const fileSelectedHandlerImageLoad = async (e) => {
    setCourseImage(null);
    const name = url.concat(e);
    const imgSrc = `${name}?w=164&h=164&fit=crop&auto=format`;
    // eslint-disable-next-line no-shadow
    setCourseImage({ img: imgSrc });
  };

  useEffect(() => {
    if (currentItem.data) {
      setCurrentItem(currentItem.data);
    }
    if (currentItem) {
      setValues(setValue, currentItem);
    }
  }, [currentItem]);

  useEffect(() => {
    if (currentItem?.videos?.length > 0) {
      let _videos = currentItem.videos.filter((video) => video.display === '1');
      _videos = _videos.sort((a, b) => Number(a?.pivot?.order) - Number(b?.pivot?.order));
      _videos = _videos.map((video) => String(video.id));
      setSelectedVideos(_videos);
    }
    if (currentItem.id && currentItem.attachments && currentItem.attachments[0]) {
      if (currentItem.attachments[0].slug === 'image') {
        fileSelectedHandlerImageLoad(currentItem.attachments[0].path);
      }
      if (currentItem.attachments[0].slug === 'banner') {
        fileSelectedHandlerLoad(currentItem.attachments[0].path);
      }
    }
    if (currentItem.id && currentItem.attachments && currentItem.attachments[1]) {
      if (currentItem.attachments[1].slug === 'image') {
        fileSelectedHandlerImageLoad(currentItem.attachments[1].path);
      }
      if (currentItem.attachments[1].slug === 'banner') {
        fileSelectedHandlerLoad(currentItem.attachments[1].path);
      }
    }
    if (currentItem?.related_courses) {
      const _courses = [];
      for (let i = 0; i < currentItem?.related_courses.length; i++) {
        _courses.push(currentItem?.related_courses[i].id);
      }
      setSelectedCourses(_courses);
    }
  }, [currentItem.id]);

  const onSubmit = () => {
    setLoading(true);
    const _currentItem = { ...currentItem };
    if (currentItem.display) {
      _currentItem.display = '1';
    } else {
      _currentItem.display = '0';
    }
    if (currentItem.new) {
      _currentItem.new = '1';
    } else {
      _currentItem.new = '0';
    }
    if (currentItem.special) {
      _currentItem.special = '1';
    } else {
      _currentItem.special = '0';
    }
    if (currentItem.popular) {
      _currentItem.popular = '1';
    } else {
      _currentItem.popular = '0';
    }
    _currentItem.videos = {};
    state.quotes?.forEach((video, index) => {
      _currentItem.videos[String(video.id)] = {
        order: index + 1,
      };
    });
    _currentItem.videos = JSON.stringify(_currentItem.videos);
    if (_currentItem.price === '0' || _currentItem.price === 0 || !_currentItem.price) {
      _currentItem.free = '1';
    } else {
      _currentItem.free = '0';
    }
    axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
    const formData = new FormData();
    for (let i = 0; i < Object.keys(_currentItem).length; i++) {
      formData.append(
        Object.keys(_currentItem)[i],
        Object.values(_currentItem)[i] ? Object.values(_currentItem)[i] : '',
      );
    }
    if (id) {
      formData.append('_method', 'put');
    }
    if (id) {
      saveItem('courses/sync-related-courses', { ids: selectedCourses }, id);
    }
    axios({
      method: 'post',
      url: id ? 'courses/'.concat(id) : 'courses',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${cookies.get('userToken')}`,
      },
    })
      .then((res) => {
        if (res.data.data) {
          navigate('/course-management/courses');
        }
        if (res?.data?.error?.email) {
          BSwalShowError(res?.data?.error?.email);
        }
      })
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentItem, setCurrentItem);
  };

  const onChangeSelectedVideo = (e) => {
    setSelectedVideos(e?.currentTarget?.value);
  };

  const onChangeSelectedCustomers = (e) => {
    setSelectedCustomers(e?.currentTarget?.value);
  };

  const attachCustomerToCourse = useCallback(() => {
    if (selectedCustomers.length > 0 && currentItem.id) {
      saveItem('courses/attach-customer-to-course', { ids: selectedCustomers }, currentItem.id).then(() => {
        setSelectedCustomers([]);
        getCourseCustomerList();
      });
    }
  }, [currentItem.id, selectedCustomers]);

  const detachCustomerToCourse = useCallback(
    (customerId) => {
      saveItem('courses/detach-customer-to-course', { ids: [String(customerId)] }, currentItem.id).then(
        getCourseCustomerList(),
      );
    },
    [currentItem.id, selectedCustomers],
  );

  useEffect(() => {
    const _videos = selectedVideos.map((videoId) => ({
      id: String(videoId),
      content: videos.find((video) => Number(video.id) === Number(videoId))?.name,
    }));
    setState({ quotes: _videos });
  }, [selectedVideos, videos]);

  const fileSelectedHandler = async (e) => {
    const _currentSlider = currentItem;
    _currentSlider.image = null;
    setCourseImage(null);
    const file = e.target.files[0];
    // eslint-disable-next-line no-shadow
    _currentSlider.image = file;
    setCurrentItem(_currentSlider);
    const reader = new FileReader();
    const url = reader.readAsDataURL(file);
    reader.onloadend = () => {
      // eslint-disable-next-line no-shadow
      setCourseImage({ img: reader.result });
    };
  };

  const fileSelectedImageHandler = async (e) => {
    const _currentSlider = currentItem;
    _currentSlider.banner = null;
    setSliderImage(null);
    const file = e.target.files[0];
    // eslint-disable-next-line no-shadow
    _currentSlider.banner = file;
    setCurrentItem(_currentSlider);
    const reader = new FileReader();
    const url = reader.readAsDataURL(file);
    reader.onloadend = () => {
      // eslint-disable-next-line no-shadow
      setSliderImage({ img: reader.result });
    };
  };

  const actions = useTableActions({
    updatePermission: '',
    deletePermission: 'courses.detachCustomersToCourse',
    editURL: '',
    removePATH: `courses/detach-customer-to-course`,
    createPermission: 'courses.attachCustomersToCourse',
  });
  const onChangeSelectedCourse = (e) => {
    setSelectedCourses(e?.currentTarget?.value);
  };
  const onChangeGetOtherPageData = (page) => {
    if (id && customers.length > 0) {
      fetchItem({
        modelName: `/courses/${id}/customer-list?page=${page}`,
        showLoader: true,
      }).then((response) => {
        if (response) {
          const res = [];
          for (let i = 0; i < response.data?.data?.length; i++) {
            if (response.data?.data[i].display === '1') {
              const user = customers.find((customer) => String(customer.id) === String(response.data?.data[i].user_id));
              if (user) {
                res.push(user);
              }
            }
          }
          setCourseCustomers(res);
        }
      });
    }
  };

  useEffect(() => {
    const raw = currentItem?.content;
    const safe = !raw || raw === 'null' ? '' : String(raw);
    setTextEditor(safe);
  }, [currentItem?.content]);

  useEffect(() => {
    if (currentItem?.service_id && selectedVideos?.length === 0) {
      setVideos(allVideos?.filter((video) => String(video?.service_id) === String(currentItem?.service_id)));
    }
    if (currentItem?.service_id && selectedVideos?.length > 0) {
      setVideos(allVideos);
    }
  }, [currentItem?.service_id]);

  return (
    <div style={{ margin: 10 }}>
      {currentItem && (
        <Card {...rest}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/course-management/courses',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'left', marginTop: '20px', marginLeft: '10px' }}
          >
            <ArrowLeftOutlined />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='اطلاعات دوره' />
            <Divider />
            <CardContent>
              <br />
              <Grid container spacing={3}>
                <BTextField
                  xs={12}
                  sm={6}
                  label='عنوان دوره برای نمایش'
                  name='description'
                  value={currentItem?.description}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.description}
                  required
                />
                <BTextField
                  xs={12}
                  sm={6}
                  label='عنوان دوره به انگلیسی'
                  name='name'
                  value={currentItem?.name}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.name}
                  required
                />
                <BSelectField
                  sm={6}
                  xs={12}
                  label='انتخاب سرویس'
                  required
                  name='service_id'
                  value={currentItem?.service_id}
                  onChange={onChange}
                  error={errors?.service_id}
                  items={convertArrayToKeyedObject(services, 'id', 'name')}
                  readOnly={viewReadOnly}
                />
                <BTextField
                  xs={12}
                  sm={6}
                  label='قیمت دوره(تومان)'
                  name='price'
                  value={currentItem?.price}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.price}
                  required
                />
                <BTextField
                  xs={12}
                  sm={6}
                  label='قیمت بعد از تخفیف(تومان)'
                  name='off_price'
                  value={currentItem?.off_price}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.off_price}
                />
                <BTextareaField
                  onChange={onChange}
                  name='upload_description'
                  sm={6}
                  xs={12}
                  value={currentItem?.upload_description}
                  label='توضیحات'
                  required
                />
                <Grid item xs={12} sm={12}>
                  <div style={{ fontSize: '16px' }}>انتخاب عکس دوره</div>
                  <span>
                    اندازه فایل آپلود شده حداکثر 4 مگابایت میباشد. فرمت عکس به صورت .webp یا jpeg/jpg یا png یا میباشد.
                  </span>
                  <br />
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .webp'
                    onChange={fileSelectedHandler}
                    style={{ marginBottom: '15px', marginTop: '15px' }}
                  />
                  {courseImage?.img && (
                    <img alt='courseImage' src={courseImage?.img} style={{ width: '200px', height: '200px' }} />
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div style={{ fontSize: '16px' }}>انتخاب بنر دوره</div>
                  <span>
                    اندازه فایل آپلود شده حداکثر 4 مگابایت میباشد. فرمت عکس به صورت .webp یا jpeg/jpg یا png یا میباشد.
                  </span>
                  <br />
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .webp'
                    onChange={fileSelectedImageHandler}
                    style={{ marginBottom: '15px', marginTop: '15px' }}
                  />
                  {sliderImage?.img && (
                    <img alt='banner' src={sliderImage?.img} style={{ width: '200px', height: '200px' }} />
                  )}
                </Grid>
                <BMultiSelectField
                  xs={12}
                  sm={12}
                  label='انتخاب ویدیوهای دوره'
                  name='videos'
                  value={selectedVideos || []}
                  onChange={onChangeSelectedVideo}
                  items={convertArrayToKeyedObject(videos, 'id', 'name')}
                  readOnly={viewReadOnly}
                />
                <Grid item xs={12}>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId='list'>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          // style={{ display: 'flex', padding: '8px', overflow: 'auto' }}
                        >
                          <h5>انتخاب ترتیب ویدیوها</h5>
                          <QuoteList quotes={state.quotes} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>

                {currentItem.id && (
                  <>
                    <BMultiSelectField
                      sm={6}
                      xs={12}
                      label='تخصیص دانشجو به دوره'
                      name='customers'
                      value={selectedCustomers || []}
                      onChange={onChangeSelectedCustomers}
                      items={convertArrayToKeyedObject(customers, 'id', 'name')}
                      readOnly={viewReadOnly || customers.length === 0}
                    />
                    <Grid item xs={12} sm={6} style={{ marginRight: '0', marginTop: '42px' }}>
                      <Button
                        id='addStudent'
                        onClick={attachCustomerToCourse}
                        color='secondary'
                        variant='outlined'
                        disabled={selectedCustomers.length === 0 || !actions[2]}
                      >
                        اضافه کردن دانشجو به دوره
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Table
                        key={key}
                        title='لیست دانشجو های دوره'
                        columns={columns}
                        createSlug='افزودن به دوره ها'
                        actions={actions}
                        tableRef={tableRef}
                        data={courseCustomers}
                        pageSize={10}
                        filtering={false}
                        removePath='courses/detach-customer-to-course'
                        removeFunction={(_id) => detachCustomerToCourse(_id)}
                        sortableColumns
                        totalPages={totalPageNumber}
                        getOtherPageData={onChangeGetOtherPageData}
                      />
                    </Grid>
                  </>
                )}
                {/* <BTextareaField
                  onChange={onChange}
                  name='content'
                  sm={12}
                  value={currentItem?.content}
                  label='درباره دوره'
                  required
                /> */}
                <label style={{ marginTop: '15px', marginBottom: '10px', fontSize: '16px' }}>توضیحات کامل دوره</label>
                <Grid item xs={12} style={{ direction: 'ltr' }}>
                  <div ref={editorContainerRef}>
                    <div ref={editorToolbarRef} />
                    <div ref={editorRef}>
                      {isLayoutReady && courses.length > 0 && (
                        <CkeditorField key={String(id)} value={textEditor} onChange={setTextEditor} />
                      )}
                    </div>
                  </div>
                </Grid>

                <BMultiSelectField
                  sm={6}
                  xs={12}
                  label='انتخاب دوره های مرتبط'
                  name='courses'
                  value={selectedCourses || []}
                  onChange={onChangeSelectedCourse}
                  items={convertArrayToKeyedObject(courses, 'id', 'description')}
                  readOnly={viewReadOnly}
                />
                <BCheckBoxField
                  sm={12}
                  name='display'
                  label='نمایش داده شود'
                  value={Number(currentItem?.display)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
                <BCheckBoxField
                  sm={12}
                  name='new'
                  label='جدید'
                  value={Number(currentItem?.new)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
                <BCheckBoxField
                  sm={12}
                  name='special'
                  label='ویژه'
                  value={Number(currentItem?.special)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
                <BCheckBoxField
                  sm={12}
                  name='popular'
                  label='محبوب'
                  value={Number(currentItem?.popular)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitClient' label='ذخیره اطلاعات' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/course-management/courses',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  بازگشت به لیست
                </Button>
              </Grid>
            </CardActions>
          </form>
        </Card>
      )}
    </div>
  );
};

export default CoursePage;
